import styled, { css } from "styled-components"
import { typography, FontConfigurations } from "theme"

import Button, { ButtonProps } from "components/buttons/shared"
import shadowCSS from "components/shadow"

const PrimaryButton = styled(Button)`
  background-color: ${props => props.theme.colors.sandy};
  color: ${props => props.theme.colors.evergreen};

  /* If 'loading' prop is not passed the hover state is inversed colors, otherwise we want to keep the initial colors */
  ${props =>
    !props.loading &&
    css`
      :hover:not([disabled]),
      :active {
        background-color: ${props.theme.colors.evergreen};
        color: ${props.theme.colors.sandy};
      }
    `}

  ${props => (props.noShadow ? "" : shadowCSS)}
`

export const PrimaryLabel = styled.label.attrs({
  ...FontConfigurations.p,
  fontWeight: "bolder"
})<ButtonProps & { htmlFor: string }>`
  display: inline-block;
  width: fit-content;

  ${props => {
    switch (props.sizing) {
      case "sm":
        return `padding: ${props.theme.space[4]} ${props.theme.space[4]};`
      case "lg":
        return `padding: ${props.theme.space[4]} ${props.theme.space[8]};`
      case "stretch":
        return `
          width: 100%;
          padding: ${props.theme.space[4]} 0;
          `
      case "md":
      default:
        return `padding: ${props.theme.space[4]} ${props.theme.space[5]};`
    }
  }}

  border-radius: ${props => props.theme.space[1]};
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s, border-color 0.2s;

  /* PrimaryButton styles */
  background-color: ${props => props.theme.colors.sandy};
  color: ${props => props.theme.colors.evergreen};
  ${props => (props.noShadow ? "" : shadowCSS)}

  ${typography}
`

export default PrimaryButton
